import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.1663 3.73205L5.95635 12.4221C5.64635 12.7521 5.34635 13.4021 5.28635 13.8521L4.91635 17.0921C4.78635 18.2621 5.62635 19.0621 6.78635 18.8621L10.0063 18.3121C10.4563 18.2321 11.0863 17.9021 11.3963 17.5621L19.6063 8.87205C21.0263 7.37205 21.6663 5.66205 19.4563 3.57205C17.2563 1.50205 15.5863 2.23205 14.1663 3.73205Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.7961 5.18359C13.2261 7.94359 15.4661 10.0536 18.2461 10.3336",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.90625 22.1328H21.9062",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }